<template>
    <div>

        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="closeErrorAndRedirect"
            />
        </div>

        <div v-if="isSuccess">
            <app-success
                v-bind:parentObject="{
                    messageSuccess: this.successMsg,
                    isSuccess: this.isSuccess,
                }"
                v-on:close-success="isSuccess = false"
            />
        </div>

        <v-container>
            <v-form ref="form">
                <v-row>
                    <h2 class="pb-5 pl-7">{{ this.parentObject.pageTitle }}<span class="page_title_value pl-1">{{ this.parentObject.pageTitleValue }}</span></h2>
                </v-row>

                <v-row>
                    <div class="pt-2 pl-7 pb-5">
                        <v-row>
                        <v-col>
                        <v-btn 
                            color="warning" 
                            style="width: 70px;"
                            @click="backHandler" 
                            > 
                            {{$t('button.back') }}
                        </v-btn>
                        </v-col>

                        </v-row>

                    </div>
                </v-row>
                
                <v-container id="scroll-target" class="overflow-y-auto px-5">
                    <div>
                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.appraisalcode')"
                                    ref="reviewcode"
                                    readonly
                                    v-model="formData.reviewcode"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>


                            <v-col cols="8" sm="8" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.appraisaldesc')"
                                    ref="description"
                                    readonly
                                    v-model="formData.description"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.periodstartdate')"
                                    ref="startdate"
                                    type="date"
                                    readonly
                                    v-model="formData.startdate"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>


                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.periodenddate')"
                                    ref="enddate"
                                    type="date"
                                    readonly
                                    v-model="formData.enddate"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.assessmenttype')"
                                    ref="assessmentcode"
                                    readonly
                                    v-model="formData.assessmentcode"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>

                    <v-card>
                        <div class="ma-4">
                            <v-subheader class="blue--text">{{$t('reportsparam.parameters')}}</v-subheader>
                            <v-row v-if="formData.assessmentcode != 'CONFIRMATION'">
                                <v-col cols="3" sm="3" class="pb-n5">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercise.servicerecordasatdate')"
                                        type="date"
                                        ref="servicerecasatdate"
                                        :rules="[rules.required]"
                                        v-model="formDataParameter.servicerecasatdate"
                                        @input="updateValue"
                                        @change="updateValue"
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row v-if="formData.assessmentcode != 'CONFIRMATION'">
                                <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercise.hirecutoffdate')"
                                        type="date"
                                        ref="hiredate"
                                        :rules="[rules.required]"
                                        v-model="formDataParameter.hiredate"
                                        @input="updateValue"
                                        @change="updateValue"
                                        dense
                                    ></v-text-field>
                                </v-col>


                                <v-col cols="5" sm="5" class="pb-n5 mt-n6">
                                    <h4 class="pt-3 grey--text font-weight-light">{{$t('pmreviewexercise.staffwithhiredate')}}</h4>
                                </v-col>

                            </v-row>

                            <v-row v-if="formData.assessmentcode != 'CONFIRMATION'">
                                <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercise.cessationcutoffdate')"
                                        type="date"
                                        ref="cessationdate"
                                        :rules="[rules.required]"
                                        v-model="formDataParameter.cessationdate"
                                        @input="updateValue"
                                        @change="updateValue"
                                        dense
                                    ></v-text-field>
                                </v-col>


                                <v-col cols="5" sm="5" class="pb-n5 mt-n6">
                                    <h4 class="pt-3 grey--text font-weight-light">{{$t('pmreviewexercise.staffwithcessationdate')}}</h4>
                                </v-col>

                            </v-row>

                            <v-row v-if="formData.assessmentcode != 'CONFIRMATION'">
                                <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercise.confirmationcutoffdate')"
                                        type="date"
                                        ref="confirmdate"
                                        :rules="[rules.required]"
                                        v-model="formDataParameter.confirmdate"
                                        @input="updateValue"
                                        @change="updateValue"
                                        dense
                                    ></v-text-field>
                                </v-col>


                                <v-col cols="5" sm="5" class="pb-n5 mt-n6">
                                    <h4 class="pt-3 grey--text font-weight-light">{{$t('pmreviewexercise.staffpriorconfirmationdate')}}</h4>
                                </v-col>

                            </v-row>

                            <v-row v-if="formData.assessmentcode == 'CONFIRMATION'">
                                <v-col cols="3" sm="3" class="pb-n5">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercise.confirmationstartdate')"
                                        type="date"
                                        ref="confirmstartdate"
                                        v-model="formDataParameter.confirmstartdate"
                                        @input="updateValue"
                                        @change="updateValue"
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3" sm="3" class="pb-n5">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercise.confirmationenddate')"
                                        type="date"
                                        ref="confirmenddate"
                                        v-model="formDataParameter.confirmenddate"
                                        @input="updateValue"
                                        @change="updateValue"
                                        dense
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="5" sm="5" class="pb-n5">
                                    <h4 class="pt-3 grey--text font-weight-light">{{$t('pmreviewexercise.applicableonlyforconfirmationreview')}}</h4>
                                </v-col>

                            </v-row>

                            <v-row>
                                <v-col cols="1" sm="1" class="pb-n5 mt-n6">
                                    <v-checkbox
                                        class="ml-n6"
                                        ref="isOverwrite"
                                        v-model="formDataParameter.isOverwrite"
                                        @input="updateValue"
                                        @change="updateValue"
                                        dense
                                    ></v-checkbox>
                                </v-col>


                                <v-col cols="7" sm="7" class="pb-n5 mt-n6 ml-n10">
                                    <h4 class="pt-3 grey--text font-weight-light">{{$t('pmreviewexercise.overwriteexsitingrecords')}}</h4>
                                </v-col>

                            </v-row>
                        </div>
                    </v-card>

                    <app-parameter 
                        class="mt-5 mb-3"
                        v-on:input="parameters = $event"
                        v-bind:parentObject="{
                            parameters: this.parameters,
                            filter: this.showFilter,
                        }"
                    /> 
                </v-container>

                <v-row>
                    <div class="pt-5 pl-7">
                        <v-row>
                        <v-col>
                        <v-btn 
                            color="primary" 
                            style="width: 100px; margin-bottom: 20px;"
                            @click="generateHandler" 
                            >
                            {{$t('button.generate')}}
                        </v-btn>
                        </v-col>

                        </v-row>

                    </div>
                </v-row>


            </v-form>
            <v-overlay :value="loading" absolute>
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-container>
    </div>
</template>

<script>
// import moment from "moment";
import FilterParameter from '../../../components/performance/reviewexercise/FilterParameter';
import ErrorDialog from "../../../components/common/ErrorDialog";
import SuccessDialog from "../../../components/common/SuccessDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
       'app-parameter': FilterParameter,
       'app-error': ErrorDialog,
       'app-success': SuccessDialog
    },


    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('periodicincentivesetup.invalidemail');
                }
            },

            //Review Exercise 
            formData: {
                pmreviewexerciseid: this.parentObject.data.id,
                reviewcode: this.parentObject.data.reviewcode,
                description: this.parentObject.data.description,
                assessmentid: this.parentObject.data.assessmentid,
                assessmentcode: this.parentObject.data.assessmentcode,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                staffFirst: this.parentObject.data.staffFirst,
                stamp: this.parentObject.data.stamp,
                userid: this.$store.getters.userId,
            },
            
            //Date Parameters
            formDataParameter: {
                servicerecasatdate: this.parentObject.dataParameter.servicerecasatdate,
                hiredate: this.parentObject.dataParameter.hiredate,
                cessationdate: this.parentObject.dataParameter.cessationdate,
                confirmdate: this.parentObject.dataParameter.confirmdate,
                confirmstartdate: this.parentObject.dataParameter.confirmstartdate,
                confirmenddate: this.parentObject.dataParameter.confirmenddate,
                isOverwrite: this.parentObject.dataParameter.isOverwrite,
            },

            //Filter Parameters
            parameters: {
                companyid: this.parentObject.parameters.companyid,
                compnyname: this.parentObject.parameters.compnyname,
                branchid: this.parentObject.parameters.branchid,
                brchname: this.parentObject.parameters.brchname,
                departmentid: this.parentObject.parameters.departmentid,
                deptname: this.parentObject.parameters.deptname,
                divisionid: this.parentObject.parameters.divisionid,
                divnname: this.parentObject.parameters.divnname,
                sectionid: this.parentObject.parameters.sectionid,
                sectioname: this.parentObject.parameters.sectioname,
                unitid: this.parentObject.parameters.unitid,
                unitname: this.parentObject.parameters.unitname,
                gradeid: this.parentObject.parameters.gradeid,
                grddesc: this.parentObject.parameters.grddesc,
                employmenttypeid: this.parentObject.parameters.employmenttypeid,
                emptypecatdesc: this.parentObject.parameters.emptypecatdesc,
                staffid: this.parentObject.parameters.staffid,
                staffcode: this.parentObject.parameters.staffcode,
                jobid: this.parentObject.parameters.jobid,
                jobtitle: this.parentObject.parameters.jobtitle,
            },

            showFilter: {
                companyid: true,
                branchid: true,
                departmentid: true,
                divisionid: true,
                sectionid: true,
                unitid: true,
                gradeid: true,
                employmenttypeid: true,
                staffid: true,
                jobid: true,
            },

            loading: false,

            errMsg: "",
            isErr: false,
            isSuccess: false,
            successMsg: ""
        }
    },

    methods: {
        closeErrorAndRedirect() {
            this.isErr = false;
            this.$router.push({ name: 'reviewexerciselist' });
        },

        async generateHandler(){
            this.loading = true;
            await this.generateStaff();
            if (this.isErr) { this.loading = false; return; }
            await this.addReviewer();
            this.loading = false;
            if (this.isErr) return;
            this.$router.push({name: 'reviewexercisegeneratestaff', params: { formData: this.formData, formDataParameter: this.formDataParameter, parameters: this.parameters}});
        },

        backHandler(){
            this.$router.push({ name: "reviewexerciseedit", params: { id: this.parentObject.data.id } });
        },

        updateValue() {
            this.$emit("input", {
                servicerecasatdate: this.formDataParameter.servicerecasatdate,
                hiredate: this.formDataParameter.hiredate,
                cessationdate: this.formDataParameter.cessationdate,
                confirmdate: this.formDataParameter.confirmdate,
                isOverwrite: this.formDataParameter.isOverwrite,
                
            });
        },

        async generateStaff() {
            const vm = this;
            //formData - Review Exercise 
            //formDataParameter - Date Parameters
            //parameters - Filter Parameters
            const data = {
                formData: vm.formData,
                formDataParameter: vm.formDataParameter,
                parameters: vm.parameters,
            };

            try {
                // Dispatch the post request with the payloads object
                const res = await this.$store.dispatch('post', { url: "/reviewexercise/generate/", payload: data });
                console.log("RESGENERATESTAFF", res.status);
                if (res.status === 201 || res.status === 200) {
                    // 201: new staff inserted, 200: all already existed — either way proceed to addReviewer
                } else {
                    vm.isErr = true;
                    vm.errMsg = res.data.error || res.data.message || 'An unexpected error occurred.';
                }
            } catch (err) {
                console.error('Error in generateStaff:', err);
                vm.isErr = true;
                vm.errMsg = err.message || String(err);
            }
        },

        async addReviewer() {
            const vm = this;
            //formData - Review Exercise 
            //formDataParameter - Date Parameters
            //parameters - Filter Parameters
            const data = {
                formData: vm.formData,
                formDataParameter: vm.formDataParameter,
                parameters: vm.parameters,
            };

            try {
                // Dispatch the post request with the payloads object
                const res = await this.$store.dispatch('post', { url: "/reviewexercise/generate/reviewer/", payload: data });

                if (res.status === 201) {
                    console.log("RESADDREVIEWER", res);
                    console.log("FORMDATA", vm.formData);
                    await vm.removeStaff(res.data.insertedRecords);
                    // await vm.generateWfTran(res.data.insertedRecords, vm.formData.staffFirst);
                } else {
                    vm.isErr = true;
                    vm.errMsg = res.data?.error || res.data?.message || 'An unexpected error occurred.';
                }
            } catch (err) {
                console.error('Error in addReviewer:', err);
                vm.isErr = true;
                vm.errMsg = err.response?.data?.error || err.message || String(err);
                if (err.response?.status === 422) {
                    await vm.removeStaff([]);
                }
            }
        },

        async removeStaff(staffRecords){
            //staffRecords - Staff Records with reviewers
            const vm = this;

            try {
                // Dispatch the post request with the payloads object
                const res = await this.$store.dispatch('put', { url: "/reviewexercise/staff/generate/" + vm.formData.pmreviewexerciseid, payload: staffRecords});

                console.log("RESREMOVESTAFF", res);

                if (res.data.status === 201) {
                    console.log("RESREMOVESTAFF", res);
                } else {
                    vm.isErr = true;
                }
            } catch (err) {
                console.error('Error in removeStaff:', err);
                vm.isErr = true;
                vm.errMsg = err.message || String(err);
            }
        },

        //No more in use because separated initiate Workflow 
        //Keep for now in case if ever need for future use
        // async generateWfTran(staffRecords, staffFirst){
        //     //staffRecords - Staff Records that has just been generated
        //     //staffFirst - indicator if staff or reviewer review first in the transaction
        //     const vm = this;

        //     const data = staffRecords.map(record => ({
        //         ...record,
        //         staffFirst
        //     }));

        //     console.log("DATA", data);
        //     try {
        //         // Dispatch the post request with the payloads object
        //         const res = await this.$store.dispatch('post', { url: "/rbwftran/review/create/", payload: data });

        //         if (res.status === 201) {
        //             console.log("RESWFTRAN", res);
        //             // console.log("RES", res);
        //             // console.log("FORMDATA", vm.formData);
        //         } else {
        //             vm.isErr = true;
        //             // Optionally handle the non-201 status here
        //         }
        //     } catch (err) {
        //         console.error('Error in generateWfTran:', err);
        //         vm.isErr = true;
        //         vm.errMsg = err;
        //     }
        // }

    },

    mounted(){

    }
}
</script>
